import * as Yup from 'yup';
import {useCallback, useRef} from 'react';
import {TextField} from '@mui/material';

export type IDefaultTextFieldProps = {
  value: string;
  error: string;
};

export const defaultTextSchema = Yup.string()
  .min(1)
  .max(255)
  .test('not-only-spaces', 'Value cannot contain only spaces', value => {
    if (value) {
      return /\S/.test(value);
    }
    return true;
  })
  .matches(
    /^[a-zA-Z0-9 ]*$/,
    'Value can only contain alphanumeric characters and spaces',
  );

export const defaultTextSchema1_50 = Yup.string()
  .min(1)
  .max(50)
  .test('not-only-spaces', 'Value cannot contain only spaces', value => {
    if (value) {
      return /\S/.test(value);
    }
    return true;
  })
  .matches(
    /^[a-zA-Z0-9 ]*$/,
    'Value can only contain alphanumeric characters and spaces',
  );

export default function DefaultTextField({
  state,
  setState,
  attr,
  schema,
}: Readonly<{
  setState: (value: IDefaultTextFieldProps) => void;
  state: IDefaultTextFieldProps;
  schema: Yup.StringSchema | Yup.NumberSchema;
  attr?: {id?: string; name?: string; label?: string};
}>) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleOnChange = useCallback(() => {
    if (inputRef.current) {
      const inputValue = inputRef.current.value;
      schema
        .validate(inputValue, {abortEarly: false})
        .then(() => {
          setState({
            value: inputValue,
            error: '',
          });
        })
        .catch((err: Yup.ValidationError) => {
          setState({
            value: inputValue,
            error: err.message,
          });
        });
    }
  }, [setState, schema]);

  return (
    <TextField
      id={attr?.id ?? 'name'}
      placeholder={attr?.label ?? 'Name'}
      name={attr?.name ?? 'name'}
      fullWidth
      inputRef={inputRef}
      error={Boolean(state.error)}
      helperText={state.error}
      defaultValue={state.value}
      onChange={handleOnChange}
      className='mb-3'
    />
  );
}
